import { z } from 'zod';

// Comenzile pe care Pluto le poate cere VPS-ului — docs/16 §5.3 si §6.1. Ajung in coada
// `vps_commands` din Supabase; agentul executa DOAR ce trece de schema de mai jos: fara
// shell, fara argumente libere, iar serviciile sunt dintr-o lista fixa.

export const RESTARTABLE_SERVICES = [
  'worker',
  'agent',
  'vector',
  'victorialogs',
  'victoriametrics',
  'vmalert',
  'alertmanager',
] as const;
export const RestartableService = z.enum(RESTARTABLE_SERVICES);
export type RestartableService = z.infer<typeof RestartableService>;

// Aceleasi nume ca BACKUP_TARGETS din platform/deploy/vps/backup/backup.sh.
export const BACKUP_TARGETS = ['v1-main', 'v1-catalog', 'v2'] as const;
export const BackupTarget = z.enum(BACKUP_TARGETS);
export type BackupTarget = z.infer<typeof BackupTarget>;

export const VpsCommand = z.discriminatedUnion('type', [
  z.strictObject({ type: z.literal('restart_service'), service: RestartableService }),
  z.strictObject({ type: z.literal('run_backup'), target: BackupTarget.optional() }),
  z.strictObject({ type: z.literal('run_restore_test'), target: BackupTarget.optional() }),
  z.strictObject({ type: z.literal('reload_settings') }),
]);
export type VpsCommand = z.infer<typeof VpsCommand>;

export const COMMAND_STATUSES = ['queued', 'running', 'done', 'failed', 'rejected'] as const;
export const CommandStatus = z.enum(COMMAND_STATUSES);
export type CommandStatus = z.infer<typeof CommandStatus>;
